import axios from "axios";
import { get } from "lodash";
import moment from "moment";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

const ACTION_TYPES = {
  FETCH_REQUIREMENTS_LIST: "applications/FETCH_REQUIREMENTS_LIST",
  FETCH_REQ_DETAILS: "applications/FETCH_REQ_DETAILS",
  FETCH_REQ_OPTIONS: "applications/FETCH_REQ_OPTIONS",
  SAVE_REQ_DETAILS: "applications/SAVE_REQ_DETAILS",
  PLACE_ORDER: "applications/PLACE_ORDER",
  NEW_REQUIREMENT: "applications/NEW_REQUIREMENT",
};

const initialState = {
  loading: false,
  requirementsList: [],
  requirementDetails: null,
};

export type ApplicationRequirementsState = Readonly<typeof initialState>;

/**
 * ApplicationRequirements Reducer
 */
export default (state: ApplicationRequirementsState = initialState, action): ApplicationRequirementsState => {
  switch (action.type) {
    case PENDING(ACTION_TYPES.FETCH_REQUIREMENTS_LIST):
    case PENDING(ACTION_TYPES.FETCH_REQ_DETAILS):
    case PENDING(ACTION_TYPES.FETCH_REQ_OPTIONS):
      return { ...state, loading: true };

    case FULFILLED(ACTION_TYPES.FETCH_REQUIREMENTS_LIST): {
      return {
        ...state,
        loading: false,
        requirementsList: action.payload.data,
      };
    }

    case FULFILLED(ACTION_TYPES.FETCH_REQ_DETAILS):
      return { ...state, loading: false, requirementDetails: action.payload.data };

    case FULFILLED(ACTION_TYPES.FETCH_REQ_OPTIONS):
      return { ...state, loading: false, requirementDetails: action.payload.data };

    case REJECTED(ACTION_TYPES.FETCH_REQUIREMENTS_LIST):
    case REJECTED(ACTION_TYPES.FETCH_REQ_DETAILS):
    case REJECTED(ACTION_TYPES.FETCH_REQ_OPTIONS):
      return { ...state, loading: false };
    case ACTION_TYPES.NEW_REQUIREMENT:
      return { ...state, requirementDetails: { ...state.requirementDetails, ...action.payload } };
    default:
      return state;
  }
};

/**
 * Actions for fetching requirements data
 */
export const fetchAppRequirementsList = ({ appId, page, rows, sort: sortOptions, query }) => {
  const sort = get(sortOptions, "0.0");
  const sortOrder = get(sortOptions, "0.1") ?? query?.sortOrder;
  return {
    type: ACTION_TYPES.FETCH_REQUIREMENTS_LIST,
    meta: { listOptions: { page, rows, sort, query } },
    payload: axios.get(`applications/${appId}/requirements`, {
      params: { rows, page, sort, sortOrder, ...query },
    }),
  };
};

export const fetchReqDetails = (reqId: string) => ({
  type: ACTION_TYPES.FETCH_REQ_DETAILS,
  payload: axios.get(`applications/requirements/${reqId}`),
});

export const fetchReqOptions = applicationId => ({
  type: ACTION_TYPES.FETCH_REQ_OPTIONS,
  payload: axios.get(`applications/${applicationId}/requirements/new`),
});

/**
 * Actions for saving requirements data
 */
export const saveReqDetails = (applicationId, reqData) => ({
  type: ACTION_TYPES.SAVE_REQ_DETAILS,
  payload: axios.post(`/applications/${applicationId}/requirements`, reqData, {
    headers: { "Content-Type": "application/json" },
  }),
});

export const placeOrder = (applicationId, reqId, vendorID) => ({
  type: ACTION_TYPES.PLACE_ORDER,
  payload: axios.post(`/applications/${applicationId}/requirements/placeOrder/${reqId}?vendorID=${vendorID}`, {
    headers: { "Content-Type": "application/json" },
  }),
});

export const newRequirement = () => ({
  type: ACTION_TYPES.NEW_REQUIREMENT,
  payload: {
    agencyOrdered: moment(new Date()).toISOString(),
    followUp: moment(new Date()).add(7, "days").toISOString(),
    requirementStatusID: 4, // TODO: fix this hardcoded value (outstanding)
  },
});
